import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'
import { reactPlugin } from '@datadog/browser-rum-react'
import {
  extractCmsSlug,
  extractGraphQLOperationNameAndErrors,
  isSupportedBrowser,
  processLogEvent,
} from '@/lib/datadog/beforeSendHandlers'
import { shouldReportError } from '@/lib/datadog/errorGrouping'

if (
  process.env.NEXT_PUBLIC_ENV === 'e2e' ||
  process.env.NEXT_PUBLIC_ENV === 'staging' ||
  process.env.NEXT_PUBLIC_ENV === 'production'
) {
  const commonConfig = {
    clientToken: process.env.NEXT_PUBLIC_DATADOG_API_KEY,
    site: 'us5.datadoghq.com' as const,
    service: 'segway',
    env: process.env.NEXT_PUBLIC_ENV,
    version:
      process.env.NEXT_PUBLIC_VERSION_TAG || // set app version to tag if present
      process.env.NEXT_PUBLIC_COMMIT_SHA || // otherwise use commit sha
      'local',
    sessionSampleRate: 100,
    silentMultipleInit: true, // Prevent warnings about multiple initializations in tests and development
  }

  datadogRum.init({
    ...commonConfig,
    applicationId: '258666b0-d235-46b0-85ba-2a5f36be52d8',
    allowedTracingUrls: [
      {
        match: /^https:\/\/(staging-)?member-api\.shipt\.com/,
        propagatorTypes: ['tracecontext'],
      },
    ],
    sessionReplaySampleRate: 0.5,
    defaultPrivacyLevel: 'allow', // https://docs.datadoghq.com/real_user_monitoring/session_replay/browser/privacy_options/
    plugins: [reactPlugin({ router: false })],
    enableExperimentalFeatures: ['feature_flags'],
    beforeSend: (event, ctx) => {
      if (!isSupportedBrowser()) {
        return false
      }
      if (event.type === 'error' && !shouldReportError(event.error.message, event.error.stack)) {
        return false
      }
      extractCmsSlug(event, ctx)
      extractGraphQLOperationNameAndErrors(event, ctx)
      return true
    },
  })
  datadogLogs.init({
    ...commonConfig,
    beforeSend: processLogEvent,
    forwardErrorsToLogs: true,
  })
}
